import PropTypes from 'prop-types';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import styles from './Timer.module.css';
import { Timer as UtilsTimer } from '@fff-web/fff-utilities';

const Timer = (props) => {
  const { expDate } = props;
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });
  const isTablet = useMediaQuery({
    query: '(min-width: 768px) and (max-width: 1023px)',
  });

  let viewSize = 'small';
  if (isTablet) {
    viewSize = 'medium';
  } else if (isDesktop) {
    viewSize = 'large';
  }

  const { minutes, seconds } = UtilsTimer.useTimer(expDate);

  return (
    <div className={`${styles.timer} ${styles[viewSize]}`}>
      <div className={`${styles.box} ${styles.minutes}`}>{minutes}m</div>
      <span>:</span>
      <div className={`${styles.box} ${styles.seconds}`}>{seconds}s</div>
    </div>
  );
};

Timer.propTypes = {
  expDate: PropTypes.instanceOf(Date).isRequired,
};

export default Timer;
